import React, { useEffect, useState } from 'react';

import Modal from 'react-modal';
import RouteComponent from './router';
import { DebugOverlay } from 'components/atoms/debugOverlay';
import { BrowserSupport } from 'components/atoms/browserSupport';
import {
  useViewport,
  ViewportProvider,
} from 'components/templates/viewportProvider';
import { apiHeaders } from 'apiClient/authorization';
import teLogo from 'assets/images/squirrel.svg';
import './assets/styles/main.scss';
import { useMediaQuery } from 'react-responsive';

Modal.setAppElement('#root');

function App() {
  const { height } = useViewport();
  const [tokenLoaded, setTokenLoaded] = useState(false);
  const isDesktopOrLaptop = useMediaQuery({
    query: '(min-device-width: 1224px)',
  });
  const isBigScreen = useMediaQuery({ query: '(min-device-width: 1824px)' });
  const [isMobilePortrait, setIsMobilePortrait] = useState(
    window.screen.height > window.screen.width
  );

  const iOS = () => {
    return (
      [
        'iPad Simulator',
        'iPhone Simulator',
        'iPod Simulator',
        'iPad',
        'iPhone',
        'iPod',
      ].includes(navigator.platform) ||
      // iPad on iOS 13 detection
      (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
    );
  };

  const handlePortraitMode = () => {
    setIsMobilePortrait(window.screen.height > window.screen.width);
  };
  const isPortrait = useMediaQuery({ query: '(orientation: portrait)' });

  const isMobile = useMediaQuery({
    maxDeviceWidth: 767,
  });
  const isTabletLandscape = useMediaQuery({
    minWidth: 1024,
    maxWidth: 1366,
  });

  const isLockOrientation =
    (isDesktopOrLaptop && !isPortrait) ||
    isBigScreen ||
    (isMobile && isMobilePortrait && !iOS()) ||
    (isTabletLandscape && !isPortrait) ||
    (isMobile && iOS() && isPortrait);

  const fetchCurrentBrowser = () => {
    // Internet Explorer 6-11
    const isIE = false || !!document.documentMode;

    return isIE;
  };

  const fetchToken = async () => {
    await apiHeaders(false);
    setTokenLoaded(true);
  };

  const isInternetExplorer = fetchCurrentBrowser();

  window.addEventListener('resize', handlePortraitMode);

  useEffect(() => {
    fetchToken();
  }, []);

  return (
    <div style={{ height }}>
      {isInternetExplorer ? (
        <BrowserSupport />
      ) : isLockOrientation ? (
        tokenLoaded ? (
          <ViewportProvider>
            <RouteComponent />
            <DebugOverlay />
          </ViewportProvider>
        ) : (
          <p className={'website-placeholder'}>
            <img src={teLogo} alt={'Total Environment'} />
          </p>
        )
      ) : (
        <div className={'orientation-lock'}>
          <span>
            <i className="fa fa-info-circle fa-2x" aria-hidden="true" /> Please
            rotate your device{' '}
          </span>
          <>
            <h3>
              We don't support {isPortrait ? 'portrait' : 'landscape'} yet.
            </h3>{' '}
            <h3>
              Please go back to {isPortrait ? 'landscape' : 'portrait'} mode for
              the best experience.
            </h3>
          </>
        </div>
      )}
    </div>
  );
}

export default App;
